// extracted by mini-css-extract-plugin
export default {"advertCardFooter":"c-a_ip","advertCardFooter__row":"c-a_iq","advertCardFooter__name":"c-a_ir","advertCardFooter__price":"c-a_is","advertCardFooter__age":"c-a_it"};